/**
 * Creates a single token
 */
class Token {
	/**
	 * Saves data in the instance
	 *
	 * @param {Object}  options              The options
	 * @param {String}  options.id           The token ID
	 * @param {String}  options.type         The token type (similar to the field type, with some exceptions)
	 * @param {String}  options.name         The token name
	 * @param {Boolean} options.cacheable    Whether Automator should cache the token node
	 * @param {Boolean} options.requiresUser Whether the token requires user data to be used
	 * @return {undefined}
	 */
	constructor( { id, type = 'text', name, cacheable = true, requiresUser = false, options = {}, itemID } ) {
		// Save data
		this.id = id;
		this.type = this.typeCasting( id, type );
		this.name = name;
		this.cacheable = cacheable;
		this.requiresUser = requiresUser;
		this.options = options;
		this.itemID = itemID;
	}

	/**
	 * Returns true if the passed token ID matches the ID of the token instance
	 *
	 * @param {String} tokenID The token ID
	 * @return {Boolean}         True if tokenID matches the token ID
	 */
	is( tokenID ) {
		return tokenID == this.id;
	}

	/**
	 * Returns the correct token type based on the token ID
	 * 
	 * @deprecated This method is deprecated and will be removed once the backend handles the token type casting
	 * @param {String} tokenID The token ID
	 * @param {String} type The original token type
	 * @return {String} The type of the token
	 */
	typeCasting( tokenID, type ) {
		if ( tokenID.endsWith( '_ID' ) ) {
			return 'int';
		}
		
		if ( tokenID.endsWith( '_DATE' ) ) {
			return 'date';
		}
		
		if ( tokenID.endsWith( '_TIME' ) ) {
			return 'time';
		}
		
		if ( tokenID.endsWith( '_URL' ) ) {
			return 'url';
		}
		
		if ( tokenID.endsWith( '_EMAIL' ) ) {
			return 'email';
		}

		return type;
	}
}

export default Token;